import retailerContext from "@modern/services/retailer_context";
import Flash from "@shared/services/flashv2";
import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import type { RetailerType } from "@shared/types/Retailer";

export const isOnProductTypeHeaderPage = page => {
  let productTypeHeaderPages: RegExp[] = [
    /^.*product_listing$/,
    /^.*distributors$/,
    /^.*storefront/,
    /^.*index$/,
  ];
  return productTypeHeaderPages.some(regex => regex.test(page.path));
};

export const updateLiquorLicense = async (
  retailerId: number,
  attrs: { [key: string]: any },
): Promise<RetailerType> => {
  try {
    const response = await HttpPromise({
      method: "PUT",
      url: `/api/retailer/user/retailers/${retailerId}`,
      data: {
        retailer: {
          liquor_license: attrs.liquorLicense,
          liquor_license_ack: attrs.liquorLicenseAck,
          license_terms_ack_by_user_id: attrs.licenseTermsAckByUserId,
        },
      },
    });

    updateCurrentRetailer(response);

    return retailerContext.get();
  } catch (_e) {
    Flash.now({
      message:
        "Sorry - we had a problem updating your license. Please try again or contact support.",
      type: "error",
    });
  }
};

function updateCurrentRetailer(updatedRetailer: RetailerType): void {
  let currentRetailer: RetailerType = window["$rootScope"].retailers.find(
    (retailer: RetailerType) => retailer.id === updatedRetailer.id,
  );

  window["$rootScope"].retailers = [
    ...window["$rootScope"].retailers.filter(
      (retailer: RetailerType) => retailer.id !== currentRetailer.id,
    ),
    { ...currentRetailer, ...updatedRetailer },
  ];

  retailerContext.initialize(window["$rootScope"].retailers);
}
